import React from 'react';
import _ from 'lodash'

import ExpandableFilters from './components/ExpandableFilters'
import PopoverListFilter from './components/PopoverListFilter'
import PopoverMoreFilters from './components/PopoverMoreFilters'
import PopoverSliderFilter from './components/PopoverSliderFilter'
import SortOrder from './components/SortOrder'

import {
  filterKeys,
  filterBarOptions,
  filtersRequiringDestinations,
} from '../../configuration/filtering'
import labels from '../../configuration/labels'
import '../../styles/scss/filters/filter-bar.scss';

const popoverOptions = {
  [`${filterKeys.countries}`]: PopoverListFilter,
  [`${filterKeys.destinationIncludes}`]: PopoverListFilter,
  [`${filterKeys.duration}`]: PopoverSliderFilter,
  [`${filterKeys.nationalParks}`]: PopoverListFilter,
  [`${filterKeys.regions}`]: PopoverListFilter,
  [`${filterKeys.trains}`]: PopoverListFilter,
  [`${filterKeys.vacationTypes}`]: PopoverListFilter,
  [`${filterKeys.famousRoutes}`]: PopoverListFilter
}

const FilterBar = () => {
  return (
    <div
      id="ylg__site-search-settings_filter-bar"
      className="u-flex u-flex-wrap filter-bar"
    >
      <h6
        className="filter-bar__header"
        dangerouslySetInnerHTML={{ __html: labels.filterBarTitle}}
      />
      <div className="filter-bar__desktop-container">
        <div className="u-flex filter-bar__desktop-container__filters">
          {_.map(filterBarOptions, key => {
            const Popover = popoverOptions[key]
            if (Popover) {
              return (
                <Popover
                  key={key}
                  filterKey={key}
                  saveFiltersByKey={_.includes(filtersRequiringDestinations, key)}
                />
              )
            }
            return null
          })}
        </div>
        <div className="filter-bar__desktop-container__sort">
          <PopoverMoreFilters />
          <SortOrder />
        </div>
      </div>
      <div className="filter-bar__mobile-container">
          <ExpandableFilters>
            {_.map(filterBarOptions, key => {
              const Popover = popoverOptions[key]
              if (Popover) {
                return (
                  <Popover
                    key={key}
                    filterKey={key}
                    saveFiltersByKey={_.includes(filtersRequiringDestinations, key)}
                  />
                )
              }
              return null
            })}
            <PopoverMoreFilters />
          </ExpandableFilters>
          <SortOrder />
      </div>
    </div>
  );
};

export default FilterBar;
